import {useMutation, useQueryClient} from '@tanstack/react-query';
import {ConversationMessage} from '@/types/conversationMessage';
import contentSubmissionVersionMessagesUpdaters from '@/api/updaters/contentSubmissionVersionMessages';
import {CONTENT_SUBMISSION_VERSION_MESSAGES_QUERY_KEY} from '@/hooks/queries/use-content-submission-version-messages';

type SendVersionMessageParams = {
  versionId: string;
  body: string;
  sentFromBrandId?: string;
};

function useSendVersionMessage() {
  const queryClient = useQueryClient();

  return useMutation<ConversationMessage, Error, SendVersionMessageParams>({
    mutationKey: ['contentSubmissionVersions', 'sendMessage'],
    mutationFn: contentSubmissionVersionMessagesUpdaters.sendMessage,
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({
        queryKey: [
          CONTENT_SUBMISSION_VERSION_MESSAGES_QUERY_KEY,
          variables.versionId,
        ],
      });
    },
  });
}

export default useSendVersionMessage;
